import { useQuery, QueryConfig, useMutation, queryCache } from "react-query";
import { spaces } from "../services/spaces";
import { buildSpaceCacheKeys, SpaceView } from "./utils";
import { snackbar } from "../components/snackbar";
import { formatMessage } from "lib/globalize-util";

export const useFetchMySpaces = (
    merchantId: string,
    isExternalCall?: boolean,
    options?: QueryConfig<nuorder.folder.v1.Space[]>
) => {
    return useQuery<nuorder.folder.v1.Space[]>(
        buildSpaceCacheKeys(merchantId, undefined, undefined, {
            isSpaceList: true,
            isExternalCall,
            spaceView: SpaceView.MyDrive,
        }),
        () =>
            spaces.fetchMySpaces(merchantId).then((responseJson) => {
                return responseJson.spaces;
            }),
        options
    );
};

export const useFetchMerchantSpaces = (
    merchantId: string,
    isExternalCall?: boolean,
    options?: QueryConfig<nuorder.folder.v1.Space[]>
) => {
    return useQuery<nuorder.folder.v1.Space[]>(
        buildSpaceCacheKeys(merchantId, undefined, undefined, {
            isSpaceList: true,
            isExternalCall,
            spaceView: SpaceView.MerchantDrive,
        }),
        () =>
            spaces.fetchMerchantSpaces(merchantId).then((responseJson) => {
                return responseJson.spaces;
            }),
        options
    );
};

export const useCreateSpace = (merchantId: string, onSuccess?: (data: nuorder.folder.v1.Space) => void) => {
    return useMutation(spaces.createSpace, {
        onSuccess: (data: nuorder.folder.v1.Space) => {
            queryCache.setQueryData(
                buildSpaceCacheKeys(merchantId, undefined, undefined, {
                    isSpaceList: true,
                    spaceView: SpaceView.MerchantDrive,
                }),
                (old: nuorder.folder.v1.Space[]) => {
                    const newPermissions = [...old, data];
                    return newPermissions;
                }
            );
            onSuccess && onSuccess(data);
        },
        onError: (_error) => {
            snackbar.show(formatMessage("There was an error creating the space"));
        },
    });
};
